import React from "react";
import "../../assets/MOCK_OD/scss/modules/anim.scss";
import "../../assets/MOCK_OD/scss/modules/checklist.scss";
import "../../assets/MOCK_OD/scss/modules/personaldetails.scss";
import "../../assets/MOCK_OD/scss/modules/questionnaire.scss";
import "../../assets/MOCK_OD/scss/modules/accordian.scss";
import Footer from '../Includes/Layouts/MOCK_OD/Footer';
import GetVisitorsParams from "../../Utility/GetVisitorsParams";
import QuestionsV2_UFC_DC_4_2 from "../Includes/Layouts/UFC_DC_4_2/QuestionsV2";

const CreditQuest_MOCK_OD_UFC_DC_4_2 = ({ onComplete }) => {
    return (
        <>
            <div className='MOCK_OD'>
                <GetVisitorsParams />
                <QuestionsV2_UFC_DC_4_2 onComplete={onComplete}/>
                {/* <Footer /> */}
            </div>
        </>
    )
}

export default CreditQuest_MOCK_OD_UFC_DC_4_2;
